module.exports = __webpack_public_path__ + "static/media/Thilina.ec383b9c.JPG";